module.exports = __webpack_public_path__ + "static_portal/img/new_training_profile.be222cb6.jpg";